import { retryImport } from 'import'
import type { ConvertHeicFileType } from './HeicConverter'

export function isHeicFile(file: File): boolean {
  return file.type === 'image/heic' || file.type === 'image/heif'
}

export async function importConvertHeicFile(): Promise<ConvertHeicFileType> {
  return await retryImport(
    () => import('services/HeicConverter'),
    'HeicConverter'
  ).then(({ default: convertHeicFile }) => convertHeicFile)
}
